import { render, staticRenderFns } from "./EventClientsEnabled.vue?vue&type=template&id=b621164e&scoped=true&"
import script from "./EventClientsEnabled.vue?vue&type=script&lang=js&"
export * from "./EventClientsEnabled.vue?vue&type=script&lang=js&"
import style0 from "./EventClientsEnabled.vue?vue&type=style&index=0&id=b621164e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b621164e",
  null
  
)

export default component.exports